import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';
import { css } from '@lyearn/style';

const quizDialogTopMarginMobile = 12;
const quizHeaderMobileHeight = 96;
const quizHeaderEmbedMobileHeight = 96;

export const questionContainerStyles = (isEmbed?: boolean) => css`
  @media ${BREAKPOINT_QUERIES.Mobile} {
    height: calc(
      100% -
        ${isEmbed
          ? quizHeaderEmbedMobileHeight
          : quizHeaderMobileHeight + quizDialogTopMarginMobile}px
    );
  }
`;

const quizReviewHeaderHeight = 49;
const quizReviewEmbedHeaderHeight = 90;

export const quizReviewContainerStyles = (isEmbed?: boolean) => css`
  @media ${BREAKPOINT_QUERIES.Mobile} {
    height: calc(
      100% -
        ${isEmbed
          ? quizReviewEmbedHeaderHeight
          : quizReviewHeaderHeight + quizDialogTopMarginMobile}px
    );
  }
`;
